import { useEffect, useState } from 'react';
import {
	FormGroup,
	InputTextblock,
	Layout,
	RadioButton,
} from '../../../components';
import { useNavigate, useParams } from 'react-router-dom';
import {
	getDataDetail,
	uploadAttendEvent,
} from '../../../service/questionerService';
import Lottie from 'lottie-react';
import successAnimation from '../../../assets/lotties/animation-success.json';
import { showMessage } from '../../../utls/message';
import { Tquestioner } from '../../../type/questioner';

const QuestionerForm = () => {
	const [questioner, setQuestioner] = useState<Tquestioner | undefined>();
	const [onSubmit, setOnSubmit] = useState(false);

	const { slug } = useParams();

	const navigator = useNavigate();

	const getDataQuestionerDetail = async (slug: string) => {
		const response = await getDataDetail(slug);

		if (!response?.error) {
			const newData = response?.data;
			const listQuestion = response?.data.questionnaireDetails.map(
				(item: any) => {
					if (item.valueText !== null) {
						return {
							...item,
							valueInput: '',
							valueText: item.valueText.split(';'),
						};
					}
					return item;
				}
			);

			newData.questionnaireDetails = listQuestion;

			setQuestioner(newData);
		}
	};

	// Function to update valueText of a specific questionnaire detail
	const updateValueInput = (index: number, newValueInput: string) => {
		setQuestioner((prevState: any) => {
			const updatedDetails = [...prevState.questionnaireDetails]; // Create a copy of the array
			updatedDetails[index].valueInput = newValueInput; // Update the valueText property
			return { ...prevState, questionnaireDetails: updatedDetails }; // Update state with the modified array
		});
	};

	const handleSubmit = async () => {
		const formData = new FormData();
		// formData.append('id', event.id?.toString() || '');
		// formData.append('feedback', feedback ? feedback : '');

		const response = await uploadAttendEvent(formData);
		if (response?.code === 200) {
			setOnSubmit(true);
		} else {
			showMessage(response?.message, 'error');
		}
	};

	useEffect(() => {
		if (slug) {
			getDataQuestionerDetail(slug);
		}
	}, []);

	return (
		<>
			{onSubmit && (
				<div className="mx-auto !max-w-[480px]">
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden bg-[#1C274C] opacity-[86%]"></div>
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden flex flex-col items-center justify-center">
						<Lottie
							animationData={successAnimation}
							className="w-[268px]"
						/>
						<h1 className="text-white text-[18px] font-bold">
							File berhasil diupload
						</h1>
						<button
							className="flex items-center gap-4 my-8"
							onClick={() => navigator(`/admin/events/all`)}
						>
							<img
								src="/assets/imgs/icon-arrow-left.svg"
								alt=""
							/>
							<p className="text-[16px] text-white">Back to home</p>
						</button>
					</div>
				</div>
			)}
			<Layout
				showNavBar={false}
				showNavigation={true}
			>
				<div className="mb-[7rem] mt-5 min-h-screen overflow-auto">
					<h1 className="text-base font-bold">{questioner?.name}</h1>
					<p className="text-sm my-2">{questioner?.description}</p>

					<div className="mt-[20px] mx-[10px]">
						{questioner?.questionnaireDetails &&
							questioner?.questionnaireDetails.map((item: any, index: number) =>
								item.valueType == 'text' ? (
									<FormGroup
										label={`${item.name}`}
										key={index}
									>
										<InputTextblock
											placeholder={`Tuliskan ${item.name}`}
											value={item.valueInput}
											onChange={(e) => updateValueInput(index, e.target.value)}
										/>
									</FormGroup>
								) : (
									<FormGroup
										label={`${item.name}`}
										key={index}
									>
										<div className="w-full flex flex-col gap-2">
											{item.valueText &&
												item.valueText.map(
													(valueItem: any, indexValueItem: number) => (
														<RadioButton
															key={indexValueItem}
															value={valueItem}
															checked={item.valueInput === valueItem}
															onChange={(e) => {
																updateValueInput(index, e.target.value);
															}}
															label={`${valueItem}`}
														/>
													)
												)}
										</div>
									</FormGroup>
								)
							)}

						<div className="my-5 flex justify-between gap-4">
							<button
								className="w-full px-[44px] py-[12px] text-[13px] rounded-[8px] hover:opacity-80 text-white bg-[#156CF7]"
								onClick={() => handleSubmit()}
							>
								Kirim
							</button>
						</div>
					</div>
				</div>
			</Layout>
		</>
	);
};

export default QuestionerForm;
